import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MediaVideo from '@adv-mt/mt-media-video'

import {useLandingInstantOfferTracking} from '../../../../../useLandingInstantOfferTracking'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-PanelLearnC2BProcess'

const PanelLearnC2BProcess = ({plateFormRef}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const isMobile = config.get('isMobile')
  const isDesktop = !isMobile

  const {trackVideoPlayed} = useLandingInstantOfferTracking()

  const scrollToWrapperElement = () => {
    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: plateFormRef.current.offsetTop - 50
    })
  }

  const Button = (
    <AtomButton
      fullWidth={isMobile}
      onClick={scrollToWrapperElement}
      shape={atomButtonShapes.CIRCULAR}
      size={atomButtonSizes.LARGE}
    >
      {`Obtener tasación`}
    </AtomButton>
  )
  const title = 'Descubre cómo funciona el proceso de venta'
  const videoYoutubeId = 'jcSr3NSGJJA'

  return (
    <div className={`${BASE_CLASS_NAME}Container`}>
      <div className={BASE_CLASS_NAME}>
        <div className={`${BASE_CLASS_NAME}Content`}>
          <h1 className={`${BASE_CLASS_NAME}ContentTitle`}>{title}</h1>
          <p className={`${BASE_CLASS_NAME}ContentDescription`}>
            {
              'Te lo explicamos paso a paso, desde el momento que llegas a la cita con tu vehículo para realizar la revisión hasta la formalización de la venta.'
            }
          </p>
          {isDesktop && Button}
        </div>
        <div className={`${BASE_CLASS_NAME}Video`}>
          <MediaVideo
            onClickPlaceholder={trackVideoPlayed}
            placeholderImageSrc={`${URL_STATICS_IMAGES}coches/instant-offer/how-to-video-placeholder.jpg`}
            preventIframeLoad
            title={title}
            videoId={videoYoutubeId}
            videoURL={`https://www.youtube-nocookie.com/embed/${videoYoutubeId}?rel=0`}
          />
        </div>
        {isMobile && Button}
      </div>
    </div>
  )
}

PanelLearnC2BProcess.displayName = 'PanelLearnC2BProcess'

PanelLearnC2BProcess.propTypes = {
  // `Element` is a DOM global and this declaration is evaluated at module load,
  // so referencing it bare throws `Element is not defined` during SSR.
  plateFormRef: PropTypes.shape({
    current: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.object
  })
}

export default PanelLearnC2BProcess
